import { Button, Input, MyTableComponent } from "components"
import { Box } from "theme-ui"
import arrowRight from "./arrowright.webp"
export const FacilitySearch = () => {
 const data = [
  {
   info1: "Forum Gera",
   info2: "Stm.5",
   info3: "Fourm Gera",
   info4: "41",
   info5: "Schwer gestort",
   info6: arrowRight,
  },
  {
   info1: "Forum Gera",
   info2: "Stm.5",
   info3: "Fourm Gera",
   info4: "41",
   info5: "Schwer gestort",
   info6: arrowRight,
  },
  {
   info1: "Forum Gera",
   info2: "Stm.5",
   info3: "Fourm Gera",
   info4: "41",
   info5: "Schwer gestort",
   info6: arrowRight,
  },
  {
   info1: "Forum Gera",
   info2: "Stm.5",
   info3: "Fourm Gera",
   info4: "41",
   info5: "Schwer gestort",
   info6: arrowRight,
  },

  {
   info1: "Forum Gera",
   info2: "Stm.5",
   info3: "Fourm Gera",
   info4: "41",
   info5: "Schwer gestort",
   info6: arrowRight,
  },
  {
   info1: "Forum Gera",
   info2: "Stm.5",
   info3: "Fourm Gera",
   info4: "41",
   info5: "Schwer gestort",
   info6: arrowRight,
  },
 ]

 const columns = [
  { Header: "Zentrale", accessor: "info1" },
  { Header: "Anlage", accessor: "info2" },
  {
   Header: "Ort",
   accessor: "info3",
  },
  {
   Header: "Felderat-Nr",
   accessor: "info4",
  },
  {
   Header: "Gerätestatus",
   Cell: ({ row }: any) => (
    <div className="flex">
     <div className="bg-red w-6 h-6 mr-2" />
     <span>{row.original.info5}</span>
    </div>
   ),
  },

  {
   Header: "Details",
   Cell: ({ row }: any) => (
    <div className="flex justify-center">
     <img src={row.original.info6} alt="arrowRight" />
    </div>
   ),
  },
 ]

 return (
  <div className="w-[96%] mx-auto pt-6">
   <h1 className="Jakarta-font font-semibold pb-3">Anlagensuche</h1>
   <Box bg="highlight" className=" py-3 px-4">
    <Input
     className="bg-gray py-2 px-2 outline-none rounded text-black mb-3"
     label="Abbreviation:"
     type="text"
     placeholder="Enter System Attributes here..."
    />
    <Input
     className="bg-gray py-2 px-2 outline-none text-black rounded"
     label="Location:"
     type="text"
     placeholder="Enter location here..."
    />
    <div className="flex justify-between items-center pt-3">
     <p className="Jakarta-font text-xs">
      Some other information about these fields to clear the user to fill them*
     </p>
     <div>
      {" "}
      <Button size={"xl"}>Perform Search</Button>
     </div>
    </div>
   </Box>
   <div className="mt-3 overflow-x-auto overflow-y-auto w-full mx-auto hide-scroll-icon">
    <Box bg="highlight" color="text-black" className="w-[140%]">
     <h1 className="font-semibold Jakarta-font ml-4 pb-4 pt-2">Anlagen</h1>
    </Box>
    <MyTableComponent fullHeight={true} columns={columns} data={data} paginate={false} />
   </div>
  </div>
 )
}
